import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import NoAvatar from "../../images/no_avatar.jpg"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Table from "../../components/Table/Table"
// Styles
import { Container, Main, Wrapper, TitleWrapper, Title, WideBox, StyledLink } from "./FavoriteList.styles"
import { UserDetails, UserInfo, UserImage, UserColumn, ProductDetail, ProductImage, ProductDetails, ProductInfo } from "./FavoriteList.styles"

const FavoriteList = () => {
    const users = useSelector((state) => state.user.users)
    const [favorites, setFavorites] = useState([])

    useEffect(() => {
        for (let i = 0; i < users.length; i++) {
            for (let j = 0; j < users[i].favoriteProducts.length; j++) {
                setFavorites((prev) => {
                    return [...prev, {
                        ...users[i].favoriteProducts[j],
                        userId: users[i]._id,
                        username: users[i].username,
                        userType: users[i].type,
                        userAvatar: users[i].img
                    }]
                })
            }
        }
    }, [users])

    const header = [
        { name: "Product", size: 70, align: "left" },
        { name: "User", size: 30, align: "left" },
    ]

    let data = []
    for (let i = 0; i < favorites.length; i++) {
        data.push([
            <StyledLink to={`/product/${favorites[i].productId}`}>
                <ProductDetail>
                    <ProductImage src={favorites[i].imageUrl} />
                    <ProductDetails>
                        <ProductInfo><b>Model : </b>{favorites[i].model}</ProductInfo>
                        <ProductInfo><b>Code : </b>{favorites[i].code}</ProductInfo>
                        <ProductInfo><b>Color : </b>{favorites[i].detailedColor}</ProductInfo>
                        <ProductInfo><b>Size : </b> {favorites[i].size}</ProductInfo>
                    </ProductDetails>
                </ProductDetail>
            </StyledLink>,
            <StyledLink to={`/user/${favorites[i].userId}`}>
                <UserColumn>
                    <UserImage src={favorites[i].userAvatar || NoAvatar} alt="" />
                    <UserDetails>
                        <UserInfo>
                            {favorites[i].username + " / " + favorites[i].userType}
                        </UserInfo>
                        <UserInfo>
                            {favorites[i].userId}
                        </UserInfo>
                    </UserDetails>
                </UserColumn>
            </StyledLink>
        ])
    }

    return (
        <>
            <Topbar />
            <Container>
                <Wrapper>
                    <Sidebar />
                </Wrapper>
                <Main>
                    <TitleWrapper>
                        <Title>Favorite Products List</Title>
                    </TitleWrapper>
                    <WideBox>
                        <Table data={data} headers={header} pageSize={20} />
                    </WideBox>
                </Main>
            </Container>
        </>
    )
}

export default FavoriteList